<!-- Support widget -->
<div (click)="iconClick()" *ngIf="show">
    <fa-icon [icon]="['fal', 'question-circle']" [ngClass]="{ 'fixed': fixed }" size="lg" class="st-text-theme-primary"></fa-icon>
</div>